"use client";

import * as React from "react";
import { Check, ArrowRight, FileText, ChartBar, House } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PerformanceEnergetique() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}